import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterClinic from './pages/RegisterClinic';
import AdminDashboard from './pages/AdminDashboard';
import MasterAdminDashboard from './pages/MasterAdminDashboard';
import TenantSettings from './pages/TenantSettings';
import AuditLogs from './pages/AuditLogs';
import DocumentSearch from './pages/DocumentSearch';
import ApproveUsers from './pages/ApproveUsers';
import ExpiringPrescriptions from './pages/ExpiringPrescriptions';
import ManageHealthUnits from './pages/ManageHealthUnits';
import Reports from './pages/Reports';
import VaccinationCard from './pages/VaccinationCard';
import VaccinationCardPrintPage from './pages/VaccinationCardPrint';
import DeliveryDates from './pages/DeliveryDates';
import ValidatePrescription from './pages/ValidatePrescription';
import ValidateExamRequest from './pages/ValidateExamRequest';
import PatientHistory from './pages/PatientHistory';
import Goals from './pages/Goals';
import { Toaster } from '@/components/ui/sonner';
import { OfflineProvider } from '@/contexts/OfflineContext';
import OfflineBanner from '@/components/OfflineBanner';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <OfflineProvider>
      <div className="App">
        <OfflineBanner />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-clinic" element={<RegisterClinic />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin-dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            {/* Master Admin - apenas para gustavobarrosjm@gmail.com */}
            <Route
              path="/admin-master"
              element={
                <ProtectedRoute>
                  <MasterAdminDashboard />
                </ProtectedRoute>
              }
            />
            {/* Configurações do Tenant/Clínica */}
            <Route
              path="/tenant-settings"
              element={
                <ProtectedRoute>
                  <TenantSettings />
                </ProtectedRoute>
              }
            />
            {/* Logs de Auditoria */}
            <Route
              path="/audit-logs"
              element={
                <ProtectedRoute>
                  <AuditLogs />
                </ProtectedRoute>
              }
            />
            {/* Busca de Documentos */}
            <Route
              path="/document-search"
              element={
                <ProtectedRoute>
                  <DocumentSearch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/approve-users"
              element={
                <ProtectedRoute>
                  <ApproveUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expiring-prescriptions"
              element={
                <ProtectedRoute>
                  <ExpiringPrescriptions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/manage-units"
              element={
                <ProtectedRoute>
                  <ManageHealthUnits />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vaccination-card/:patientId"
              element={
                <ProtectedRoute>
                  <VaccinationCard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/vaccination-card/:patientId/print"
              element={
                <ProtectedRoute>
                  <VaccinationCardPrintPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/delivery-dates"
              element={
                <ProtectedRoute>
                  <DeliveryDates />
                </ProtectedRoute>
              }
            />
            {/* Rota protegida para histórico do paciente */}
            <Route
              path="/paciente/:patientId/historico"
              element={
                <ProtectedRoute>
                  <PatientHistory />
                </ProtectedRoute>
              }
            />
            {/* Rota protegida para metas */}
            <Route
              path="/goals"
              element={
                <ProtectedRoute>
                  <Goals />
                </ProtectedRoute>
              }
            />
            {/* Rota pública para validação de receitas */}
            <Route path="/validar" element={<ValidatePrescription />} />
            <Route path="/validar/:prescriptionId" element={<ValidatePrescription />} />
            {/* Rota pública para validação de exames */}
            <Route path="/validar-exame/:requestId" element={<ValidateExamRequest />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </OfflineProvider>
  );
}

export default App;